import ListPresentationConstants from '../constants/ListPresentationConstants';

function toggleListView(view) {
  return {
    type: ListPresentationConstants.TOGGLE_LIST_VIEW,
    payload: {
      view
    }
  };
}

export default {
  toggleListView
};
